// @flow
import * as React from 'react';
import * as Sentry from '@sentry/browser';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from './Common/Button';

const Container = styled.div`
  max-width: 800px;
  margin: 15px auto;

  @media (max-width: 769px) {
    margin: 15px;
  }
`;

const FlexWell = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  text-align: center;
`;

const ButtonContainer = styled.div`
  display: flex;
  margin-top: 1.5rem;

  button:last-child {
    margin-left: 1rem;
  }
`;

class ErrorBoundary extends React.Component<
  {
    children: React.Node
  },
  {
    error: ?Error
  }
> {
  state = {
    error: null
  };

  componentDidCatch(
    error: Error,
    errorInfo: {
      componentStack: string
    }
  ) {
    this.setState({ error });
    Sentry.configureScope(scope => {
      Object.keys(errorInfo).forEach(key => {
        scope.setExtra(key, errorInfo[key]);
      });
    });
    Sentry.captureException(error);
  }

  handleGoHome = () => {
    this.setState({ error: null });
    window.location.href = window.location.origin;
  };

  render() {
    if (this.state.error) {
      return (
        <Container>
          <FlexWell>
            <FontAwesomeIcon
              icon="exclamation-circle"
              color="#777777"
              size="5x"
            />
            <h3>Oops! Something went wrong</h3>
            <p>An unexpected error has occurred.</p>
            <p>
              If the problem persists please contact your system administrator.
            </p>
            <ButtonContainer>
              <Button kind="primary" onClick={() => Sentry.showReportDialog()}>
                Report Feedback
              </Button>
              <Button kind="secondary" onClick={this.handleGoHome}>
                Go Home
              </Button>
            </ButtonContainer>
          </FlexWell>
        </Container>
      );
    } else {
      return this.props.children;
    }
  }
}

export default ErrorBoundary;
